import moment from "moment";
import { AuthStatusOptionModel } from "../../../../../data-model/authStatusOptions";
import { CptCodesTableRowModel } from "../../../../../data-model/cptCodesTableModel";
import { getAuthStatusIdFromText } from "../../../../../enums/medicalPaOrdersAuthStatus";
import { getOrgIdForFetchExternalWorklist } from "../../../../../utils/organizationHelper";

export const transformTableDataToApiPayload = (
  tableData: CptCodesTableRowModel[],
  authStatusOptions: AuthStatusOptionModel[],
  orderId: string,
) => {
  const j_codes = tableData.map((row) => {
    const start_date = row.startFrom?.data
      ? moment(new Date(row.startFrom.data).toISOString()).format("MM/DD/YYYY")
      : "";
    const end_date = row.endAt?.data
      ? moment(new Date(row.endAt.data).toISOString()).format("MM/DD/YYYY")
      : "";

    return {
      id: row.jCodeId || "",
      j_code: row.jCodes.data || "",
      start_date: start_date,
      end_date: end_date,
      num_visits: parseInt(row.visits?.data ?? "0") || 0,
      auth_status:
        getAuthStatusIdFromText(
          row.paRequired?.text,
          authStatusOptions ?? [],
        ) || "",
      medicine_name: row.description.text || "",
      description: row.description.text || "",
      visits_happened: parseInt(row.visitsAllowed?.data ?? "0") || 0,
      visits_remaining: parseInt(row.remainingVisits?.data ?? "0") || 0,
      comment_date: new Date().toISOString(),
    };
  });

  return {
    identifier: orderId,
    j_codes: j_codes,
    org_id: getOrgIdForFetchExternalWorklist() || "",
  };
};
